module.exports = __webpack_public_path__ + "img/profesor_2.d45d0215.webp";